// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2cIFe","savePackageButton":"ClientWallet_savePackageButton__QD2--"};